<form [formGroup]="form">
  <div *ngIf="createForm">
    <div class="container-fluid" [hidden]="indexPage < 1 || indexPage > 5">
      <div class="row">
        <div class="col-md-11">
          <div class="sticky-top fixedtop" *ngFor="let page of pages; let i = index">
            <div id="step{{ i+1 }}" *ngIf="indexPage === (i+1) && getIsCheckValid(indexPage)">
              <app-form-errors
                [stepid]="'_STEP_ID_' + (i+1)"
                [linkForRouter]="linkForRouter">
              </app-form-errors>
          </div>
          </div>
          <div [class]="formClass">
            <fieldset>
              <legend *ngIf="indexPage > 0 && indexPage < 5">
                {{ getIntitule(indexPage) | translate }}
              </legend>

              <app-step1
                *ngIf="indexPage === 1"
                [parentForm]="form"
                [avisInitial]="this.ann.mapa.annulationFromMAPA.avisInitial"
                [disabled]="disabled"
                [linkForRouter]="linkForRouter"
                [uid]="getUid(1)"
              >
              </app-step1>

              <app-step1common
                *ngIf="indexPage === 2"
                [uid]="getUidCommon(2)"
                [parentForm]="form"
                [disabled]="disabled"
                [mapa]="ann.mapa"
                [linkForRouter]="linkForRouter"
              >
              </app-step1common>

              <app-step2
                *ngIf="indexPage === 3"
                [parentForm]="form"
                [description]="ann.mapa.annulationFromMAPA.description"
                [disabled]="disabled"
                [linkForRouter]="linkForRouter"
                [uid]="getUid(3)"
              >
              </app-step2>

              <app-step3
                *ngIf="indexPage === 4"
                [parentForm]="form"
                [annulation]="ann.mapa.annulationFromMAPA.infosAnnulation"
                [disabled]="disabled"
                [linkForRouter]="linkForRouter"
                [uid]="getUid(4)"
              >
              </app-step3>

              <!--app-step2common
      [uid]="'_COMMON_ID_2' + getUidCommon()"
      [parentForm]="form"
      [disabled]="disabled"
      [mapa]="ann.mapa"
      [hidden]="indexPage != 8"

      [linkForRouter]="linkForRouter">
    </app-step2common-->
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
